// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"layout_layoutWrapper__7Oang","mainWrapper":"layout_mainWrapper__itrpz"};